import { edmCampaign } from '@bingads-webui/edm-campaign';

const assetGroupEDM = edmCampaign.types.resolve('Model.AssetGroup');
const assetGroupResource = new assetGroupEDM.ResourceIdentifier();

export const updateAssetGroup = ({
  assetGroupId,
  campaignId,
  updateValues,
}) =>
  assetGroupResource.bulkUpdate({
    Id: assetGroupId,
    Campaign: { Id: campaignId },
    ...updateValues,
  });

export const bulkUpdateAssetGroups = ({
  assetGroups,
  campaignId,
  updateValues,
}) =>
  assetGroupResource.bulkUpdateMany(
    assetGroups.map(assetGroup => assetGroup.Id),
    assetGroups.map(() => ({
      Campaign: { Id: campaignId },
      ...updateValues,
    }))
  );
